$(function () {
  'use strict';

  if ($('form.apply-job-form').length > 0) {
    const dir = $('html').attr('dir');

    $.validator.addMethod("emailPattern", function (value, element) { // new method for email validation
      return this.optional(element) || /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value);
    });
    $.validator.addMethod("numberPattern", function (value, element) {
      return this.optional(element) || $(element).intlTelInput("isValidNumber");
    });
    $.validator.addMethod("idnumberPattern", function (value, element) {
      return this.optional(element) || /^[0-9]+$/.test(value);
    });
  
    const messagesError = {
      first_name: {
        en: 'Please provide your first name',
        ar: 'رجاء كتابة اسمك الأول'
      },
      second_name: {
        en: 'Please provide your second name',
        ar: 'رجاء كتابة اسمك الثاني'
      },
      last_name: {
        en: 'Please provide your last name',
        ar: 'رجاء كتابة اسمك الأخير'
      },
      id_number: {
        required: {
          en: 'Please provide your ID number',
          ar: "رجاء إدخال رقم الهوية الخاصة بك"
        },
        numberPattern: {
          en: 'Please enter a valid ID number',
          ar: 'رجاء ادخال رقم هوية صحيح'
        }
      },
      email: {
        en: 'Please enter a valid email address',
        ar: 'رجاء إدخال عنوان بريد إلكتروني صالح'
      },
      number: {
        required: {
          en: 'Please provide your number without country code',
          ar: "يرجى تقديم رقمك بدون رمز البلد"
        },
        numberPattern: {
          en: 'Please enter a valid number',
          ar: "رجاء إدخال رقم هاتف صحيح"
        }
      },
      edq: {
        en: 'Please choose education qualification',
        ar: 'الرجاء اختيار المؤهل التعليمي'
      },
      spec: {
        en: 'Please provide specialization',
        ar: 'الرجاء اختيار التخصص'
      },
      job_status: {
        en: 'Please choose current job status',
        ar: 'الرجاء اختيار الحالة الوظيفية الحالية'
      },
      years: {
        en: 'Please provide years of experience',
        ar: 'يرجى تقديم سنوات الخبرة'
      },
      sector: {
        en: 'Please choose sector of previous experience',
        ar: 'الرجاء اختيار قطاع الخبرة السابقة'
      },
      employer: {
        en: 'Please provide previous employer',
        ar: 'يرجى تقديم صاحب العمل السابق'
      },
    }
  
    $('form.apply-job-form').validate({
      rules: {
        // name: 'required',
        // 'education-qualification': 'required',
        // specialization: 'required',
        // 'current-status': 'required',
        // experience: 'required',
        // 'sector-previous-experience': 'required',
        // 'prev-employer': 'required',
        'number': {
          // required: true,
          numberPattern: true
        },
        'personal-id-nmber': {
          // required: true,
          idnumberPattern: true
        },
        'email': {
          // required: true,
          emailPattern: true
        },
        // 'curriculum-upload': 'required',
        // 'degrees-upload': 'required'
      },
      messages: {
        'first_name': dir == 'ltr'? messagesError.first_name.en : messagesError.first_name.ar,
        'second_name': dir == 'ltr'? messagesError.second_name.en : messagesError.second_name.ar,
        'last_name': dir == 'ltr'? messagesError.last_name.en : messagesError.last_name.ar,
        'number': {
          required : dir == 'ltr'? messagesError.number.required.en : messagesError.number.required.ar,
          numberPattern: dir == 'ltr'? messagesError.number.numberPattern.en : messagesError.number.numberPattern.ar
        },
        'personal-id-nmber': {
          required: dir == 'ltr'? messagesError.id_number.required.en : messagesError.id_number.required.ar,
          idnumberPattern: dir == 'ltr'? messagesError.id_number.numberPattern.en : messagesError.id_number.numberPattern.ar
        },
        'email': {
          required: dir == 'ltr'? messagesError.email.en : messagesError.email.ar,
          emailPattern: dir == 'ltr'? messagesError.email.en : messagesError.email.ar
        },
        'education-qualification': dir == 'ltr'? messagesError.edq.en : messagesError.edq.ar,
        'specialization': dir == 'ltr'? messagesError.spec.en : messagesError.spec.ar,
        'current-status': dir == 'ltr'? messagesError.job_status.en : messagesError.job_status.ar,
        'experience': dir == 'ltr'? messagesError.years.en : messagesError.years.ar,
        'sector-previous-experience': dir == 'ltr'? messagesError.sector.en : messagesError.sector.ar,
        'prev-employer': dir == 'ltr'? messagesError.employer.en : messagesError.employer.ar,
      },
      errorElement: 'em',
    })
  }
})